import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getEditorViewStateOutsideOrgContent, getEditorViewStateMessageContent, } from '../selectors/getStoreProperties';
/**
 * Utility function to get external message
 * @returns external message from store
 */
export default function getExternalMessage() {
    var isEnterpriseUser = !isConsumer();
    if (isEnterpriseUser) {
        return getEditorViewStateOutsideOrgContent();
    }
    else {
        return getEditorViewStateMessageContent();
    }
}
//# sourceMappingURL=getExternalMessage.js.map